/**
 * SectionHeader — page section divider with optional subtitle + action slot.
 * Used to separate cards/tables within a page.
 *
 * Usage:
 *   <SectionHeader title="Sales Summary" subtitle="Filtered by today" action={<Button>Export</Button>} />
 */

export function SectionHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={`flex items-start justify-between mb-4 ${className}`}>
      <div>
        <h2
          className="text-[14px] font-semibold leading-snug"
          style={{ fontFamily: 'Manrope, sans-serif', color: 'var(--text-primary)' }}
        >
          {title}
        </h2>
        {subtitle && (
          <p className="text-[12px] mt-0.5" style={{ color: 'var(--text-tertiary)' }}>
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="ml-4 flex-shrink-0">{action}</div>}
    </div>
  );
}
